export function isOffice() {
  return (window.location.search.includes("office")
    || window.location.hostname.includes("office"))
}